import React, { useState, useContext } from "react";
import { useMsal } from '@azure/msal-react';
import SiteAccessContext from '../../contexts/SiteAccessContext';

export const Profile = (props) => {

    const { assignedSites } = useContext(SiteAccessContext);

    const [dropdown, setDropdown] = useState(false);
    const { instance } = useMsal();
    const handleSignOut = () => {
        instance.logoutPopup({
            postLogoutRedirectUri: window.runtimeConfig.WEBSITE_FRONTEND_URI || '/',
        });
      };
    return (
        <div className={dropdown ? "subMenu1 clicked" : "subMenu1"} onClick={() => setDropdown(!dropdown)}>
            <div className="submenu-item ipad1"><span>Username : {props && props.username ? props.username : ''}</span></div>
            <div className="submenu-item ipad1"><span>Privileges : {props.privileges && props.privileges.join(', ')}</span></div>
            <div className="submenu-item ipad1"><span>Sites : {assignedSites && assignedSites.map(site => '(' + site.siteId + ') ' + site.siteName).toString()}</span></div>
            <div className="submenu-item ipad1"><button type="button" className="btn btn-outline-secondary" onClick={handleSignOut}>Logout</button></div>
        </div>
    );
};